import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Coffee } from "lucide-react";

export default function ServerWakeOverlay() {
  const [waking, setWaking] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    const onDown = () => setWaking(true);
    window.addEventListener("pmo-server-down", onDown);
    return () => window.removeEventListener("pmo-server-down", onDown);
  }, []);

  useEffect(() => {
    if (!waking) return;
    const poll = async () => {
      try {
        await axios.get(`${API}/health`, { timeout: 8000 });
        setWaking(false);
        toast.success("All warmed up — the system is ready to go!", { duration: 5000 });
        setTimeout(() => window.location.reload(), 1200);
      } catch (e) {
        timer.current = setTimeout(poll, 6000);
      }
    };
    timer.current = setTimeout(poll, 4000);
    return () => clearTimeout(timer.current);
  }, [waking]);

  if (!waking) return null;
  return (
    <div className="fixed inset-x-0 bottom-6 z-[100] flex justify-center px-4" data-testid="server-wake-banner">
      <div className="flex items-start gap-3 max-w-lg w-full rounded-xl border border-amber-300 bg-amber-50 shadow-lg px-5 py-4">
        <Coffee className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
        <div className="text-sm text-amber-900 min-w-0">
          <p className="font-bold">Sandbox environment warming up…</p>
          <p className="text-xs mt-1">This preview environment sleeps when idle. It's waking up now — usually takes just a few minutes. Sit tight, we'll let you know the moment it's ready.</p>
        </div>
        <Loader2 className="h-4 w-4 animate-spin text-amber-600 shrink-0 mt-0.5" />
      </div>
    </div>
  );
}
